<template>
  <el-select
    class="select-style"
    v-bind="$attrs"
    @change="changeValue"
    v-on="$listeners"
  >
    <template #prefix>
      <div class="prefix_icon">
        <div :class="prefix_icon_type">
          <span
            class="svg-wrapper"
            alt=""
          />
        </div>
      </div>
    </template>
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      @click.native="handleClick(item.value)"
    >
      <div :class="item.icon">
        <span
          class="svg-wrapper"
          alt=""
        />
        <span class="text-style">{{ item.label }}</span>
      </div>
    </el-option>
  </el-select>
</template>

<script>
const getOptions = ($t) => [{
  value: 3,
  label: $t('sortSelect.type1'),
  icon: 'type3'
}, {
  value: 2,
  label: $t('sortSelect.type2'),
  icon: 'type2'

}, {
  value: 1,
  label: $t('sortSelect.type3'),
  icon: 'type1'
}, {
  value: 0,
  label: $t('sortSelect.type4'),
  icon: 'type0'
}]
export default {
  name: 'SortSelect',
  props:{
    all_show:{
      type:Boolean,
      default:true
    }
  },
  data(){
    return {
      prefix_icon_type:''
    }
  },
  watch:{
    '$attrs.value':{
      immediate:true,
      handler(_new){
        this.prefix_icon_type = 'type'+_new
      }
    }
  },
  created () {
    this.options = getOptions(this.$t)
    if(!this.all_show){
      this.options = this.options.slice(0,2)
    }
  },
  methods: {
    changeValue (v) {
      sessionStorage.setItem('selectedSortType', v)
    },

    handleClick(value) {
      this.$emit('option-click', value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .prefix_icon{
    padding-left: 5px;
    line-height: 36px;
  }
  .select-style {
    width: 12em;
  }
  .text-style {
    vertical-align: middle;
    &:hover {
      color: #0046AA
    }
  }
  .svg-wrapper {
    vertical-align: middle;
    display: inline-block;
    height: 18px;
    width: 18px;
  }
  .selected {

  }
  .type3 {
    .svg-wrapper {
      background: url("~@/assets/img/svg/sort-down-word.svg");
    }
  }
  .selected .type3, .type3:hover {
    .svg-wrapper {
      background: url('~@/assets/img/svg/sort-down-word-active.svg');
    }
  }
  .type2 {
    .svg-wrapper {
      background: url("~@/assets/img/svg/sort-down-reword.svg");
    }
  }
  .selected .type2, .type2:hover {
    .svg-wrapper {
      background: url('~@/assets/img/svg/sort-down-reword-active.svg');
    }
  }
  .type1 {
    .svg-wrapper {
      background: url('~@/assets/img/svg/sort-up.svg');
    }

  }
  .selected .type1, .type1:hover {
    .svg-wrapper {
      background: url('~@/assets/img/svg/sort-up-active.svg');
    }
  }
  .type0 {
    .svg-wrapper {
      background: url('~@/assets/img/svg/sort-down.svg');
    }
  }
  .selected .type0, .type0:hover {
    .svg-wrapper {
      background: url('~@/assets/img/svg/sort-down-active.svg');
    }
  }
  // .select-style ::v-deep ul{
  //   width: 100% !important;
  //   display: block !important;
  // }
  // .select-style ::v-deep ul li{
  //   width: 100% !important;
  //   margin-top: 0px !important;
  //   line-height: 34px !important;
    
  // }
  // .select-style ::v-deep .el-select-dropdown{
  //   top: 40px !important;
  //   left:0px !important;
  //   position: absolute !important;
  // }
</style>
